import { Box, useMediaQuery } from "@mui/material";
import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import React, { useMemo } from "react";
import { COLOR } from "../../../../../themes/components/utils";
import { AccountTypeSwitch } from "../../client/parallax/AccountTypeSwitch";
import { LandingStepG } from "../../client/steps/LandingStepG";
import {
  DESKTOP_MIN_HEIGHT,
  DESKTOP_NAVBAR_HEIGHT,
  MOBILE_NAVBAR_HEIGHT,
  PROFESSIONAL_DESKTOP_VIEW_CONFIG,
} from "../../constants";
import { CurrentPageContent } from "../../CurrentPageContent";
import { useScrollEffects } from "../../hooks";
import { Topbar } from "../../Topbar";
import {
  LandingStepA,
  LandingStepB,
  LandingStepBContent,
  LandingStepBHeadline,
  LandingStepC,
  LandingStepCContent,
  LandingStepCHeadline,
  LandingStepD,
  LandingStepDContent,
  LandingStepDHeadline,
  LandingStepE,
  LandingStepEContent,
  LandingStepEHeadline,
  LandingStepF,
} from "../steps";

export const professionalDesktopPages = [
  <React.Fragment />,
  <LandingStepB />,
  <LandingStepC />,
  <LandingStepD />,
  <LandingStepE />,
  <LandingStepF />,
  <LandingStepG />,
];

export const professionalMobilePages = [
  <React.Fragment />,
  <LandingStepBHeadline />,
  <LandingStepBContent />,
  <LandingStepCHeadline />,
  <LandingStepCContent />,
  <LandingStepDHeadline />,
  <LandingStepDContent />,
  <LandingStepEHeadline />,
  <LandingStepEContent />,
  <LandingStepF />,
  <LandingStepG />,
];

export const ProfessionalLargeViewParallax = () => {
  const { backgroundColors, pagesCount } = PROFESSIONAL_DESKTOP_VIEW_CONFIG;
  const mobileHeight = useMediaQuery("(max-height: 750px)", { noSsr: true });

  const { isScrolling, currentVisibleView, lastVisitedView } = useScrollEffects(
    {
      pagesCount,
      backgroundColors,
    }
  );

  const height = useMemo(() => {
    if (mobileHeight) return MOBILE_NAVBAR_HEIGHT;

    return DESKTOP_NAVBAR_HEIGHT;
  }, [mobileHeight]);

  return (
    <Box height="100%">
      <Topbar
        height={height * (isScrolling ? 0.8 : 1)}
        containerProps={{
          top: 0,
          position: "fixed",
        }}
      />
      <Parallax
        className="parallax-container"
        style={{
          backgroundColor: COLOR.PINK,
        }}
        pages={pagesCount}
      >
        <ParallaxLayer
          style={{
            justifyContent: "flex-start",
          }}
        >
          <LandingStepA />
          <AccountTypeSwitch defaultChecked="professional" />
        </ParallaxLayer>
        <ParallaxLayer
          sticky={{ start: 1, end: pagesCount - 2 }}
          style={{
            justifyContent: "flex-start",
            alignItems: "center",
            height: "100%",
            minHeight: DESKTOP_MIN_HEIGHT,
          }}
        >
          <Box height="100%" display="flex" justifyContent="center">
            <CurrentPageContent
              desktopPages={professionalDesktopPages}
              mobilePages={professionalMobilePages}
              currentPage={currentVisibleView}
              previousPage={lastVisitedView}
            >
              <AccountTypeSwitch defaultChecked="professional" />
            </CurrentPageContent>
          </Box>
        </ParallaxLayer>
        <ParallaxLayer
          offset={pagesCount - 1}
          style={{ minHeight: DESKTOP_MIN_HEIGHT }}
        >
          <LandingStepA />
        </ParallaxLayer>
      </Parallax>
    </Box>
  );
};
